import React, {useState} from 'react';
import {Calendar} from 'primereact/calendar';
import classNames from 'classnames';
import {ErrorMessage} from 'formik';
import _ from 'lodash';

import {ja} from './locale';
import * as handlers from './handlers';
import {Props} from './types';
import Error from './../Error';

import './index.scss';

const DatePicker: React.FC<Props> = props => {
  const {field, ...restProps} = props;
  const [viewDate, setViewDate] = useState<Date>(new Date());

  return (
    <div className="a__date-picker">
      <Calendar
        className={classNames({dark: props.dark})}
        showWeek={false}
        dateFormat="yy/mm/dd"
        onChange={_.throttle(handlers.onChangeDate(props), 50)}
        showOnFocus={props.isAutoOpen}
        locale={ja}
        value={field.value || null}
        viewDate={viewDate}
        onViewDateChange={({value}) => {
          setViewDate(value);
        }}
        name={field.name}
        showIcon={true}
        {...restProps}
      />
      <ErrorMessage name={props.field.name} component={Error} />
    </div>
  );
};

export default DatePicker;
